import { motion } from "framer-motion";

export default function SectionHead({ overline, title, sub }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="max-w-2xl"
    >
      <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#D4AF37]">{overline}</p>
      <h2 className="mt-4 font-serif text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">{title}</h2>
      {sub && <p className="mt-4 text-base leading-relaxed text-white/60">{sub}</p>}
    </motion.div>
  );
}
